module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAMFBMVEX///9HcEz///////////////////////////////////////////////9HcEz////pywJoAAAAD3RSTlPzANmtzOy9n5Rx4x4vgABzEnQDAAAAyElEQVQY02NYwAAEhglAgovhPwgk6oNIhvjg9uJ4Q3/mimJ+hnhDQUF/Q39HQcH1QLZqIYidmqjPEF/4XxHE5v8IZBu2TwSxp18EshPB6hXB6plUlPgT/T+pKH2AmO8YDza/vRwIJl4vNjauYBBEAAYnJSBoNAKakAR1z/+PgoJA97CkpfAnlticFkyBmJ8ouP8nUH28YVIjiP0XxAa5J1Hw/E/BG0DxsosQNf+R1K9n+P81NPR/YoL2joD/DEtBDjHUXyjxnwsAfuljQpd6ZtgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/suspension/code.png
// module id = p+QS
// module chunks = 6